import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
export function Dialog({ open, onOpenChange, children }) {
    const handleEscape = useCallback((e) => {
        if (e.key === 'Escape')
            onOpenChange(false);
    }, [onOpenChange]);
    useEffect(() => {
        if (!open)
            return;
        document.addEventListener('keydown', handleEscape);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = '';
        };
    }, [open, handleEscape]);
    if (!open)
        return null;
    return (_jsx("div", { style: {
            position: 'fixed', inset: 0, zIndex: 50,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'rgba(0,0,0,0.6)',
            padding: '16px',
        }, onClick: () => onOpenChange(false), children: _jsx("div", { style: {
                width: '100%', maxWidth: '448px',
                borderRadius: 'var(--radius-lg)',
                border: '1px solid var(--color-border-strong)',
                background: 'var(--color-surface)',
                padding: '24px',
                boxShadow: '0 24px 80px rgba(0,0,0,0.5)',
            }, onClick: (e) => e.stopPropagation(), children: children }) }));
}
export function DialogHeader({ style, ...props }) {
    return _jsx("div", { style: { marginBottom: '16px', ...style }, ...props });
}
export function DialogTitle({ style, ...props }) {
    return (_jsx("h2", { style: {
            fontFamily: 'var(--font-family-heading)',
            fontSize: '1.125rem', fontWeight: 700,
            color: 'var(--color-text)',
            ...style,
        }, ...props }));
}
export function DialogDescription({ style, ...props }) {
    return (_jsx("p", { style: {
            marginTop: '4px', fontSize: '0.875rem',
            color: 'var(--color-text-muted)',
            fontFamily: 'var(--font-family-body)',
            ...style,
        }, ...props }));
}
export function DialogFooter({ style, ...props }) {
    return (_jsx("div", { style: {
            marginTop: '24px', display: 'flex',
            justifyContent: 'flex-end', gap: '12px',
            ...style,
        }, ...props }));
}
